import { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Account } from "./Main"
import { fetchWithAuth } from "./Utils"
import { Helmet } from "react-helmet";
import "./Profilo.css"
import "./Login.css"

const Profilo = () => {
    const [campi_edit_psw, setCampi_edit_psw] = useState([])
    const [showpsw, setshowpsw] = useState("fa-solid fa-eye")
    const [btn_text, setbtn_text] = useState("Modifica password")
    const [loading, setLoading] = useState(false)

    const { persona, setpersona, logout, showAlert } = useContext(Account);
    const navigate = useNavigate()

    useEffect(() => {
        document.body.scrollTop = 0;
    }, []);

    const showPassword = () => {
        let x = document.querySelector("#psw")
        if (x.type === "password") {
            x.type = "text"
            setshowpsw("fa-solid fa-eye-slash")
        } else {
            x.type = "password"
            setshowpsw("fa-solid fa-eye")
        }
    }

    const mod_psw = async () => {
        if (btn_text === "Aggiorna Password") {
            const password = document.querySelector("#psw").value
            const confermaPassword = document.querySelector("#conferma_psw").value

            if (!password || password.length < 8) {
                showAlert("Attenzione", "Password troppo corta (min 8 caratteri)");
                return;
            }

            if (password !== confermaPassword) {
                showAlert("Attenzione", "Le password non coincidono");
                return;
            }

            setLoading(true);

            try {
                const response = await fetchWithAuth("cambia_password.php", {
                    method: "POST",
                    body: JSON.stringify({
                        new_password: password
                    })
                });

                if (response.ok) {
                    showAlert("Attenzione", "Password modificata con successo");
                    setCampi_edit_psw([]);
                    setbtn_text("Modifica password");
                    // Clear password fields
                    document.querySelector("#psw").value = "";
                    document.querySelector("#conferma_psw").value = "";
                } else {
                    showAlert("Attenzione", response.error || "Errore nella modifica password");
                }
            } catch (error) {
                showAlert("Attenzione", "Errore di connessione");
                console.error("Password change error:", error);
            } finally {
                setLoading(false);
            }
        } else {
            setbtn_text("Aggiorna Password")
            let el_psw =
                <div className='campo psw' key={"psw"}>
                    <span>Nuova password (min 8 caratteri):</span>
                    <input type="password" autoComplete="new-password" name="password" id="psw" />
                    <i className={showpsw} onClick={showPassword}></i>
                </div>

            let el_conferma_psw =
                <div className='campo psw' key={"conferma_psw"}>
                    <span>Conferma password:</span>
                    <input type="password" autoComplete="new-password" name="conferma_password" id="conferma_psw" />
                </div>

            setCampi_edit_psw([el_psw, el_conferma_psw])
        }
    }

    const aggiorna_dati = async () => {
        const nascitaInput = document.getElementById("nascita");
        const socioInput = document.getElementById("socio");

        const nascita = nascitaInput.value;
        const socio = socioInput.checked;

        if (!nascita) {
            showAlert("Attenzione", "Inserisci la data di nascita");
            nascitaInput.focus();
            return;
        }

        // Formatta la data nel formato corretto (YYYY-MM-DD)
        const dataFormattata = new Date(nascita).toISOString().split('T')[0];

        setLoading(true);

        try {
            const response = await fetchWithAuth("aggiorna_dati.php", {
                method: "POST",
                body: JSON.stringify({
                    nascita: dataFormattata,
                    socio: socio ? 1 : 0
                })
            });

            if (response.ok) {
                showAlert("Attenzione", "Dati aggiornati con successo");

                // Aggiorna stato locale
                setpersona(prev => ({
                    ...prev,
                    nascita: dataFormattata,
                    socio
                }));

                // Aggiorna localStorage se necessario
                localStorage.setItem("socio", socio.toString());
            } else {
                showAlert("Attenzione", response.error || "Errore nell'aggiornamento dati");
            }
        } catch (error) {
            showAlert("Attenzione", error.message || "Errore di connessione");
            console.error("Update data error:", error);
        } finally {
            setLoading(false);
        }
    }

    const cancella_account = async () => {
        if (!window.confirm('ATTENZIONE: Stai per eliminare il tuo account e tutte le prenotazioni associate. Questa azione è irreversibile. Vuoi procedere?')) {
            return;
        }

        const password = prompt("Inserisci la tua password per confermare l'eliminazione:");
        if (!password) {
            return;
        }

        setLoading(true);

        try {
            const response = await fetchWithAuth("elimina_account.php", {
                method: "POST",
                headers: { "Content-Type": "application/x-www-form-urlencoded" },
                body: JSON.stringify({ password }),
            })

            if (response.ok) {
                showAlert("Attenzione", "Account eliminato con successo");
                setTimeout(() => {
                    logout();
                    navigate("/");
                }, 2000);
            } else {
                showAlert("Attenzione", response.error || "Errore nell'eliminazione account");
            }
        } catch (error) {
            showAlert("Attenzione", error.message);
            console.error("Delete account error:", error);
        } finally {
            setLoading(false);
        }
    }

    const logoutAllDevices = async () => {
        if (!window.confirm('Sei sicuro di voler effettuare il logout da tutti i dispositivi?')) {
            return;
        }

        setLoading(true);

        try {
            const response = await fetchWithAuth("logout_all.php", {
                method: "POST"
            });

            if (response.ok) {
                showAlert("Attenzione", "Logout da tutti i dispositivi effettuato");
                // Rimuove token locali e reset stato utente
                localStorage.clear();
                logout();
                navigate("/login");
            } else {
                showAlert("Attenzione", response.error || "Errore nel logout globale");
            }
        } catch (error) {
            showAlert("Attenzione", "Errore di connessione");
            console.error("Logout all devices error:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleLogout = () => {
        logout();
        navigate("/");
    }

    if (!persona.access_token) {
        navigate("/login");
        return null;
    }

    return (
        <>
            <Helmet>
                <title>Sporting - Profilo</title>
                <meta
                    name="description"
                    content="Gestisci il tuo profilo nella web app Sporting Saluzzo."
                />
            </Helmet>

            <div id="profilo">
                {loading && <div className="loading-overlay">Caricamento...</div>}

                <div id="profilo-cont">
                    <div id="user-logo">
                        <i className="fa-solid fa-user"></i>
                        <h1>{persona.nome} {persona.cognome}</h1>
                    </div>

                    <div id="user_dati_cont">
                        <h1>I tuoi dati:</h1>

                        <div id="dati_input">
                            <div className='dato campo distanza'>
                                <span>Username:</span>
                                <input
                                    type='text'
                                    disabled={true}
                                    name="username"
                                    id="username"
                                    value={persona.username}
                                />
                            </div>

                            <div className='dato campo distanza'>
                                <span>Email:</span>
                                <input
                                    type='email'
                                    disabled={true}
                                    name="email"
                                    id="email"
                                    value={persona.email}
                                />
                            </div>

                            <div className='dato campo distanza'>
                                <span>Data di nascita:</span>
                                <input
                                    disabled={true}
                                    type='date'
                                    name="nascita"
                                    id="nascita"
                                    value={persona.nascita}
                                />
                            </div>

                            <div className='dato campo distanza'>
                                <span>Socio:</span>
                                <label className="switch">
                                    <input
                                        type="checkbox"
                                        id="socio"
                                        name="socio"
                                        defaultChecked={persona.socio}
                                    />
                                    <span className="slider round"></span>
                                </label>
                            </div>

                            {campi_edit_psw}
                        </div>

                        <div className="button-group">
                            <button
                                onClick={aggiorna_dati}
                                disabled={loading}
                                className={loading ? 'loading' : ''}
                            >
                                {loading ? 'Caricamento...' : 'Aggiorna Dati'}
                            </button>

                            <button
                                onClick={mod_psw}
                                disabled={loading}
                                className={loading ? 'loading' : ''}
                            >
                                {loading ? 'Caricamento...' : btn_text}
                            </button>

                            <button onClick={handleLogout} disabled={loading}>
                                Esci
                            </button>
                            <h3>Altro</h3>
                            <button onClick={logoutAllDevices} disabled={loading} className="danger">
                                Esci da tutti i dispositivi
                            </button>

                            <button
                                onClick={cancella_account}
                                disabled={loading}
                                className="danger"
                            >
                                Cancella account
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Profilo